import i18next from 'i18next';

export const getTranslatedFilters = () => {
    const t = (key) => i18next.t(key);

    return {
        statusFilters: [
            { text: t("Active"), value: "Active" },
            { text: t("Inactive"), value: "Inactive" },
            { text: t("Requested"), value: "Requested" },
            { text: t("Suspended"), value: "Suspended" },
            { text: t("Approved"), value: "Approved" },
            { text: t("Rejected"), value: "Rejected" },
            { text: t("Pending"), value: "Pending" },
            { text: t("Completed"), value: "Completed" },
            { text: t("Cancelled"), value: "Cancelled" }
        ],
        
        alertFilters: [
            { text: t("Red"), value: "Red" },
            { text: t("Green"), value: "Green" },
            { text: t("Gray"), value: "Gray" }
        ],

        valueFilters: [
            { text: t("*"), value: true },
            { text: t("-"), value: false }
        ],

        emailConfirmedFilters: [
            { text: t("Yes"), value: true },
            { text: t("No"), value: false }
        ],

        isOptedOutFilters: [
            { text: t("Yes"), value: true },
            { text: t("No"), value: false }
        ],

        isNhsNumberValidFilters: [
            { text: t("Yes"), value: true },
            { text: t("No"), value: false }
        ],

        dataQualityStatusFilters: [
            { text: t("Red"), value: "Red" },
            { text: t("Amber"), value: "Amber" },
            { text: t("Green"), value: "Green" }
        ],

        omopImportStatusFilters: [
            { text: t("Pending"), value: "Pending" },
            { text: t("Imported"), value: "Imported" },
            { text: t("Skipped"), value: "Skipped" },
            { text: t("Failed"), value: "Failed" }
        ],

        genderFilters: [
            { text: t("Male"), value: "Male" },
            { text: t("Female"), value: "Female" }
        ],

        roleFilters: [
            { text: t("SuperUser"), value: "SuperUser" },
            { text: t("UnauthorizedUser"), value: "UnauthorizedUser" },
            { text: t("CardiologyStaff"), value: "CardiologyStaff" },
            { text: t("TrustUserManager"), value: "TrustUserManager" },
            { text: t("Patient"), value: "Patient" }
        ],

        patientEventGroupFilters: [
            // Position, Activity and Room Interaction
            { text: t("Position"), value: "Position" },
            { text: t("Activity"), value: "Activity" },
            { text: t("Room Interaction"), value: "Room Interaction" },
        ],

        recordTypeFilters: [
            { text: t("BreastRecord"), value: "BreastRecord" },
            { text: t("CNSRecord"), value: "CNSRecord" },
            { text: t("ColorectalRecord"), value: "ColorectalRecord" },
            { text: t("CTYARecord"), value: "CTYARecord" },
            { text: t("Gynaecological"), value: "GynaecologicalRecord" },
            { text: t("HaematologicalRecord"), value: "HaematologicalRecord" },
            { text: t("LiverRecord"), value: "LiverRecord" },
            { text: t("LungRecord"), value: "LungRecord" },
            { text: t("OtherRecord"), value: "OtherRecord" },
            { text: t("SarcomaRecord"), value: "SarcomaRecord" },
            { text: t("Skin"), value: "SkinRecord" },
            { text: t("UpperGIRecord"), value: "UpperGIRecord" },
            { text: t("UrologicalRecord"), value: "UrologicalRecord" },
        ],

        /** Label for RecordType Tag display (value -> short label) */
        recordTypeTagLabel: (value) => {
            const map = {
                BreastRecord: t("BreastRecord"),
                CNSRecord: t("CNS"),
                ColorectalRecord: t("ColorectalRecord"),
                CTYARecord: t("CTYARecord"),
                GynaecologicalRecord: t("GynaecologicalRecord"),
                HaematologicalRecord: t("HaematologicalRecord"),
                LiverRecord: t("LiverRecord"),
                LungRecord: t("LungRecord"),
                OtherRecord: t("OtherRecord"),
                SarcomaRecord: t("SarcomaRecord"),
                SkinRecord: t("SkinRecord"),
                UpperGIRecord: t("UpperGIRecord"),
                UrologicalRecord: t("UrologicalRecord"),
            };
            return map[value] || value || "-";
        },
    };
};

const filters = getTranslatedFilters();
export const {
    statusFilters,
    alertFilters,
    valueFilters,
    emailConfirmedFilters,
    isOptedOutFilters,
    isNhsNumberValidFilters,
    dataQualityStatusFilters,
    genderFilters,
    roleFilters,
    patientEventGroupFilters,
    recordTypeFilters,
    recordTypeTagLabel,
} = filters;